import { SectionPublic } from '../api/CmsApi';

export default function(baseUri: string, section: SectionPublic) {
  if (section.url) {
    return `${baseUri}/${section.url}`;
  } else {
    return `${baseUri}/section/${section._id}`;
  }
}
